import { CenteredLayout, H1, Logo, PancakeStack, Text, WorkflowHeader } from '@betterment/samba-react';
import { Helmet } from 'react-helmet';

import PigeonInToolBox from '../images/errors/pigeon-in-tool-box.svg';

export default function GenericErrorPage() {
  return (
    <>
      <Helmet>
        <title>Error | Betterment</title>
      </Helmet>
      <PancakeStack css={{ maxWidth: '100%' }}>
        <PancakeStack.Header
          css={{
            maxWidth: '100%',
            display: 'flex',
            justifyContent: 'center',
            borderBottom: 'solid 1px',
            borderColor: 'border',
          }}
        >
          <WorkflowHeader css={{ width: '100%' }}>
            <WorkflowHeader.Title>
              <a href="/">
                <Logo aria-label="Betterment" type="signature" css={{ height: 'icon.small', textAlign: 'center' }} />
              </a>
            </WorkflowHeader.Title>
          </WorkflowHeader>
        </PancakeStack.Header>
        <PancakeStack.Main>
          <CenteredLayout size="large" css={{ display: 'flex', gap: 'space.200' }}>
            <img src={PigeonInToolBox} alt="pigeon-in-tool-box" width="100%" />
            <H1 variant="title300" css={{ textAlign: 'center' }}>
              Our apologies for the inconvenience. This page is currently experiencing an issue. Our team is aware and
              working to restore it as quickly as possible.
            </H1>
            <Text css={{ textAlign: 'center' }}>
              As always, your money is safe and secure during this process. If you have any questions, please contact
              our support team at <a href="mailto:support@betterment.com">support@betterment.com</a> or{' '}
              <a href="tel:7184006898">(718) 400-6898</a>.
            </Text>
          </CenteredLayout>
        </PancakeStack.Main>
      </PancakeStack>
    </>
  );
}
